<template>
  <ActionPendingModal message="Purchasing the Core Training Bundle">
    <div
      v-if="purchaseinProgressText"
      class="content-block"
      v-html="purchaseinProgressText"
    />
  </ActionPendingModal>
</template>

<script>
import ActionPendingModal from '@/components/ActionPendingModal/ActionPendingModal.vue';
import usePurchaseTrainingContent from '@/modules/Training/components/PurchaseTraining/usePurchaseTrainingContent';

export default {
  name: 'PurchaseTrainingPendingModal',
  components: {
    ActionPendingModal,
  },
  setup() {
    const { purchaseinProgressText } = usePurchaseTrainingContent();

    return {
      purchaseinProgressText,
    };
  },
};
</script>
